import BoxIcon from "@redotech/redo-icons/box-01.svg";
import { BooleanFilterOperator } from "@redotech/redo-model/views/advanced-filters/boolean-filter";
import { fgWmsFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgWmsFilterEntries.warehouseMissingBins;

export const WarehouseMissingBinsFilter: BooleanTableFilter = {
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  Icon: BoxIcon,
  displayName: entry.displayName,
  label: "Warehouse bin",
  boolDisplay: { falseDisplay: "not missing", trueDisplay: "missing" },
};
